module.exports = __webpack_public_path__ + "img/priceTable.40cef649.jpg";